// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ETicket from '../_raw/ui/icon_e_ticket.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ETicket);
